export default {"src":"/login-app/[GIT_HASH]/_next/static/media/folder_open.abf7ee62.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};